module.exports = __webpack_public_path__ + "media/assets/faria_products/PYP-a906f4cb6c8ea43b901a433647b8e9fd22fb3f3812c6751e51f8ae9d53ed4daf.png";